export enum ManifestSource {
  TEXT = 'text',
  ARTIFACT = 'artifact',
}
